import React from 'react';

const Loader = () => {
    return (
        // <div className="Authloader"></div>
        <div class="spinner-loading">
            <div class="spinner-loader"></div>
        </div >
    )
}
export default Loader